import Proptypes from 'prop-types';
import React, { useCallback } from 'react';

import SelectDropdown from './SelectDropDown';

export default function LetterSpacingFormatter({ editor }) {
  const value = editor.getTailwindValue({ name: 'letterSpacing' })?.value
  const handleClickOption = useCallback(letterSpacing => {
    letterSpacing = letterSpacing.replace('px', '')
    const newValue = letterSpacing === 'Normal' || letterSpacing === value ? null : letterSpacing.replace('px', '')
    return editor.commands.setLetterSpacing(newValue)
  }, [editor, value])

  return <SelectDropdown
    options={SIZES}
    onChange={handleClickOption}
    tooltipText='Letter Spacing'
    value={value}
    creatable
  />
}

const SIZES = ['Normal', '1px', '2px', '3px', '4px', '5px', '6px', '7px', '8px', '9px', '10px']

LetterSpacingFormatter.propTypes = {
  editor: Proptypes.object,
  tooltipText: Proptypes.string,
}
